export default "__VITE_ASSET__DfTTfOMs__"